import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

type Props = DialogProps & { onConfirm: () => void };

export const DirectSignupChangeInsuranceDialog = ({ onConfirm, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{t('directSignup.dialogs.changeInsurance.title')}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>{t('directSignup.dialogs.changeInsurance.body')}</Paragraph>
      </Dialog.Body>

      <Dialog.CTAs>
        <Button onClick={onConfirm}>{t('directSignup.dialogs.changeInsurance.confirm')}</Button>

        <Button variant="ghost" onClick={dialogProps.onDismiss}>
          {t('directSignup.dialogs.changeInsurance.cancel')}
        </Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
